/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Overviewgreetingmorning2Inputs */

const en_overviewgreetingmorning2 = /** @type {(inputs: Overviewgreetingmorning2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Good morning, ${i?.name}`)
};

const de_overviewgreetingmorning2 = /** @type {(inputs: Overviewgreetingmorning2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guten Morgen, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Good morning, {name}" |
*
* @param {Overviewgreetingmorning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewgreetingmorning2 = /** @type {((inputs: Overviewgreetingmorning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewgreetingmorning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewgreetingmorning2(inputs)
	return de_overviewgreetingmorning2(inputs)
});
export { overviewgreetingmorning2 as "overviewGreetingMorning" }